import { render, staticRenderFns } from "./CadastrarServicoUnidade.vue?vue&type=template&id=52d3243e&scoped=true"
import script from "./CadastrarServicoUnidade.vue?vue&type=script&lang=js"
export * from "./CadastrarServicoUnidade.vue?vue&type=script&lang=js"
import style0 from "./CadastrarServicoUnidade.vue?vue&type=style&index=0&id=52d3243e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d3243e",
  null
  
)

export default component.exports